/**
 * @fileoverview gRPC-Web generated client stub for acompanha.feature_flags.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/feature_flags/v1/feature_flags.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.feature_flags = {};
proto.acompanha.feature_flags.v1 = require('./feature_flags_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest,
 *   !proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse>}
 */
const methodDescriptor_FeatureFlagsService_GetEvaluatedFeatures = new grpc.web.MethodDescriptor(
  '/acompanha.feature_flags.v1.FeatureFlagsService/GetEvaluatedFeatures',
  grpc.web.MethodType.UNARY,
  proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest,
  proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse,
  /**
   * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient.prototype.getEvaluatedFeatures =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/GetEvaluatedFeatures',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_GetEvaluatedFeatures,
      callback);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient.prototype.getEvaluatedFeatures =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/GetEvaluatedFeatures',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_GetEvaluatedFeatures);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest,
 *   !proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse>}
 */
const methodDescriptor_FeatureFlagsService_ListFeatureFlags = new grpc.web.MethodDescriptor(
  '/acompanha.feature_flags.v1.FeatureFlagsService/ListFeatureFlags',
  grpc.web.MethodType.UNARY,
  proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest,
  proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse,
  /**
   * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient.prototype.listFeatureFlags =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/ListFeatureFlags',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_ListFeatureFlags,
      callback);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient.prototype.listFeatureFlags =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/ListFeatureFlags',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_ListFeatureFlags);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.feature_flags.v1.GetFeatureFlagRequest,
 *   !proto.acompanha.feature_flags.v1.GetFeatureFlagResponse>}
 */
const methodDescriptor_FeatureFlagsService_GetFeatureFlag = new grpc.web.MethodDescriptor(
  '/acompanha.feature_flags.v1.FeatureFlagsService/GetFeatureFlag',
  grpc.web.MethodType.UNARY,
  proto.acompanha.feature_flags.v1.GetFeatureFlagRequest,
  proto.acompanha.feature_flags.v1.GetFeatureFlagResponse,
  /**
   * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.feature_flags.v1.GetFeatureFlagResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient.prototype.getFeatureFlag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/GetFeatureFlag',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_GetFeatureFlag,
      callback);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient.prototype.getFeatureFlag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/GetFeatureFlag',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_GetFeatureFlag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest,
 *   !proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse>}
 */
const methodDescriptor_FeatureFlagsService_CreateFeatureFlag = new grpc.web.MethodDescriptor(
  '/acompanha.feature_flags.v1.FeatureFlagsService/CreateFeatureFlag',
  grpc.web.MethodType.UNARY,
  proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest,
  proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse,
  /**
   * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient.prototype.createFeatureFlag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/CreateFeatureFlag',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_CreateFeatureFlag,
      callback);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient.prototype.createFeatureFlag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/CreateFeatureFlag',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_CreateFeatureFlag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest,
 *   !proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse>}
 */
const methodDescriptor_FeatureFlagsService_UpdateFeatureFlag = new grpc.web.MethodDescriptor(
  '/acompanha.feature_flags.v1.FeatureFlagsService/UpdateFeatureFlag',
  grpc.web.MethodType.UNARY,
  proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest,
  proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse,
  /**
   * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient.prototype.updateFeatureFlag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/UpdateFeatureFlag',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_UpdateFeatureFlag,
      callback);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient.prototype.updateFeatureFlag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/UpdateFeatureFlag',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_UpdateFeatureFlag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest,
 *   !proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse>}
 */
const methodDescriptor_FeatureFlagsService_AddFeatureFlagUser = new grpc.web.MethodDescriptor(
  '/acompanha.feature_flags.v1.FeatureFlagsService/AddFeatureFlagUser',
  grpc.web.MethodType.UNARY,
  proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest,
  proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse,
  /**
   * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient.prototype.addFeatureFlagUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/AddFeatureFlagUser',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_AddFeatureFlagUser,
      callback);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient.prototype.addFeatureFlagUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/AddFeatureFlagUser',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_AddFeatureFlagUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest,
 *   !proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse>}
 */
const methodDescriptor_FeatureFlagsService_RemoveFeatureFlagUser = new grpc.web.MethodDescriptor(
  '/acompanha.feature_flags.v1.FeatureFlagsService/RemoveFeatureFlagUser',
  grpc.web.MethodType.UNARY,
  proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest,
  proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse,
  /**
   * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServiceClient.prototype.removeFeatureFlagUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/RemoveFeatureFlagUser',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_RemoveFeatureFlagUser,
      callback);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.feature_flags.v1.FeatureFlagsServicePromiseClient.prototype.removeFeatureFlagUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.feature_flags.v1.FeatureFlagsService/RemoveFeatureFlagUser',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagsService_RemoveFeatureFlagUser);
};


module.exports = proto.acompanha.feature_flags.v1;

